"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.ModalFooter = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const ModalFooter = ({ action, cancel, back, size = 'md' }) => {
    return size === 'md' ? (react_1.default.createElement(react_2.HStack, { flexDir: 'row-reverse', justifyContent: 'space-between' },
        react_1.default.createElement(react_2.HStack, null,
            cancel,
            action),
        back)) : (react_1.default.createElement(react_2.VStack, { alignItems: 'stretch' },
        action,
        back,
        cancel));
};
exports.ModalFooter = ModalFooter;
const Modal = ({ isOpen, onClose, header, body, Footer, size = 'md', ...props }) => {
    return (react_1.default.createElement(react_2.Modal, { ...props, isOpen: isOpen, onClose: onClose, size: size === 'md' ? 'xl' : 'sm' },
        react_1.default.createElement(react_2.ModalOverlay, null),
        react_1.default.createElement(react_2.ModalContent, null,
            header && react_1.default.createElement(react_2.ModalHeader, null, header),
            react_1.default.createElement(react_2.ModalCloseButton, null),
            body && react_1.default.createElement(react_2.ModalBody, null, body),
            Footer && (react_1.default.createElement(react_2.ModalFooter, { display: 'block' },
                react_1.default.createElement(Footer, { size: size }))))));
};
exports.Modal = Modal;
